import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/residential-foam-roof")({
  beforeLoad: () => { throw redirect({ to: "/foam-roofing", statusCode: 301 }); },
});
